var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8906 45.6008C35.317 45.6008 45.3906 35.5272 45.3906 23.1008C45.3906 10.6744 35.317 0.60083 22.8906 0.60083C10.4642 0.60083 0.390625 10.6744 0.390625 23.1008C0.390625 35.5272 10.4642 45.6008 22.8906 45.6008Z",
    fill: "#2350F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 16.9133H21.375M18.125 22.6008H27.875M18.125 25.8508H27.875M18.125 29.1008H21.375M16.5 33.1633H29.5C29.931 33.1633 30.3443 32.9921 30.649 32.6874C30.9538 32.3826 31.125 31.9693 31.125 31.5383V13.6633C31.125 13.2324 30.9538 12.819 30.649 12.5143C30.3443 12.2095 29.931 12.0383 29.5 12.0383H16.5C16.069 12.0383 15.6557 12.2095 15.351 12.5143C15.0462 12.819 14.875 13.2324 14.875 13.6633V31.5383C14.875 31.9693 15.0462 32.3826 15.351 32.6874C15.6557 32.9921 16.069 33.1633 16.5 33.1633Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 17.3196C28.0994 17.3196 28.2812 17.1377 28.2812 16.9133C28.2812 16.689 28.0994 16.5071 27.875 16.5071C27.6506 16.5071 27.4688 16.689 27.4688 16.9133C27.4688 17.1377 27.6506 17.3196 27.875 17.3196Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuill);
export default __webpack_public_path__ + "static/media/quill.9120f938a86e0a0426de98fbeb8d15b6.svg";
export { ForwardRef as ReactComponent };